module.exports = __webpack_public_path__ + "static/img/aP_Ejcaw.46b005b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/horse-nest/aP_Ejcaw.jpg
// module id = vBPT
// module chunks = 7